export default "__VITE_ASSET__DGMzsK6J__"